import React, { useState, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import ProviderCbxFilter from "../utilities/ProviderCbxFilter";

const NewAltCategoryModal = ({
  trackList,
  trackCategoryCbx,
  profiles,
  newAltCategory,
  setNewAltCategory,
  closeModalState,
  setCloseModalState,
  insertAltCategory,
  gameProviders,
  altCategories,
  getTracksListCbxNew,
}) => {
  const [newDate, setNewDate] = useState(new Date());
  const [dateValid, setDateValid] = useState(false);
  const [dateError, setDateError] = useState("");
  const [shouldReset, setShouldReset] = useState(false);
  const originalDate = new Date();
  originalDate.setHours(originalDate.getUTCHours());
  const year = originalDate.getFullYear();
  const month = ("0" + (originalDate.getMonth() + 1)).slice(-2);
  const day = ("0" + originalDate.getDate()).slice(-2);
  // Crear cadena en formato ISO 8601
  const isoString = `${year}-${month}-${day}T${"00"}:${"00"}:${"00"}Z`;
  const [selectedProviderID, setSelectedProviderID] = useState(-1);

  const filteredTracks = trackList.filter((track) => {
    const usedTrackIDs = altCategories.map((cat) => cat.TrackID);
    return !usedTrackIDs.includes(track.TrackID);
  });

  useEffect(() => {
    setNewAltCategory({
      DateFrom: isoString,
      TrackID: null,
      IDTrackCategory: trackCategoryCbx[0]?.IDTrackCategory,
      Profiles: [],
      ProviderName: "",
    });

    setSelectedProviderID(-1);
    setNewDate(new Date());
  }, [closeModalState]);

  useEffect(() => {
    if (trackList.length > 0) {
      const usedTrackIDs = altCategories.map((cat) => cat.TrackID);
      const availableTracks = trackList.filter(
        (track) => !usedTrackIDs.includes(track.TrackID),
      );

      if (availableTracks.length > 0) {
        setNewAltCategory((prev) => ({
          ...prev,
          TrackID: availableTracks[0].TrackID,
        }));
      } else {
        setNewAltCategory((prev) => ({
          ...prev,
          TrackID: null,
        }));
      }
    }
  }, [trackList]);

  let headers,
    tableProfiles = [];
  headers = (
    <tr className="text-center">
      <th hidden>ProfileID</th>
      <th>Profile</th>
    </tr>
  );

  if (profiles) {
    tableProfiles = profiles.map((profile, i) => {
      if (newAltCategory.Profiles) {
        var className = newAltCategory.Profiles.some(
          (associatedProfile) =>
            parseInt(associatedProfile.ProfileID) === profile.ProfileID,
        )
          ? "classActiveMultiselect"
          : "";
      }
      return (
        <tr key={i} className={className}>
          <td key={"ProfileID" + i} className="d-none">
            {profile.ProfileID}
          </td>
          <td
            style={{ textAlign: "center" }}
            onClick={() => profilesCategoryChangeHandler(profile.ProfileID)}
          >
            {profile.ProfileName}
          </td>
        </tr>
      );
    });
  }

  // Profiles OnChange
  const profilesCategoryChangeHandler = (profileID) => {
    const x = { ...newAltCategory };

    const profileIndex = x.Profiles.findIndex(
      (profile) => profile.ProfileID === profileID,
    );

    if (profileIndex !== -1) {
      x.Profiles.splice(profileIndex, 1);
    } else {
      x.Profiles.push({ ProfileID: profileID });
    }

    setNewAltCategory(x);
  };

  //Onchange New Alt Category
  const onChangeNewAltCategory = (e) => {
    let value = e.target.value;
    let name = e.target.name;

    if (name === "TrackID") {
      value = parseInt(value);
    }

    if (name === "IDTrackCategory") {
      value = parseInt(value);
    }
    setNewAltCategory({
      ...newAltCategory,
      [e.target.name]: value,
      Change: true,
    });
  };

  // Onchange for the Date Picker
  const dateChange = (date) => {
    if (date !== null) {
      setNewDate(date);
      const dateFrom = new Date(date.toISOString());

      const year = dateFrom.getFullYear();
      const month = ("0" + (dateFrom.getMonth() + 1)).slice(-2);
      const day = ("0" + dateFrom.getDate()).slice(-2);

      const isoString = `${year}-${month}-${day}T${"00"}:${"00"}:${"00"}Z`;

      setNewAltCategory({ ...newAltCategory, DateFrom: isoString });
      setDateValid(true);
      setDateError("");
    } else {
      setNewDate("");
      setDateValid(false);
      setDateError("* The date is required");
      setNewAltCategory({ ...newAltCategory, DateFrom: "" });
    }
  };

  useEffect(() => {
    getTracksListCbxNew(selectedProviderID);
  }, [selectedProviderID]);

  //Clean Inputs New Track Modal
  const cleanInputs = () => {
    setCloseModalState(!closeModalState);
    setDateValid(true);
  };

  return (
    <>
      <div
        className="modal fade"
        id="newAltCategoryModal"
        role="dialog"
        aria-hidden="false"
        data-keyboard="false"
        data-backdrop="static"
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.4)",
          zIndex: 1051,
        }}
      >
        <div className="modal-dialog modal-xs" style={{ margin: "4rem auto" }}>
          <div className="modal-content">
            <div
              className="modal-header"
              style={{ backgroundColor: "#5b6671", color: "#fff" }}
            >
              <h5 className="modal-title" id="newAltCategoryModal">
                New Alternative Category
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                onClick={() => cleanInputs()}
              >
                &times;
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-sm-12">
                  <form autoComplete="off">
                    {/* Date */}
                    <div className="form-inline mb-3">
                      <label
                        className="lead"
                        style={{
                          fontSize: "18px",
                          width: "80px",
                          justifyContent: "normal",
                        }}
                      >
                        Date:
                      </label>
                      <div>
                        <DatePicker
                          selected={newDate}
                          dateFormat="MM/dd/yyyy"
                          className="form-control"
                          wrapperClassName="datePicker"
                          id="DateFrom"
                          name="DateFrom"
                          autoComplete="off"
                          placeholderText="Date"
                          onChange={(date) => dateChange(date)}
                        />
                      </div>

                      <label htmlFor="DateFrom" className="mt-1 ml-2">
                        {dateValid ? (
                          ""
                        ) : (
                          <span style={{ color: "red" }}>{dateError}</span>
                        )}
                      </label>
                    </div>
                    {/* Provider */}
                    <ProviderCbxFilter
                      gameProviders={gameProviders}
                      setSelectedProvider={setSelectedProviderID}
                      selectedProvider={selectedProviderID}
                      widthCbx={"370px"}
                      label={true}
                    />
                    {/* Track */}
                    <div className="form-inline mt-3">
                      <label
                        className="lead"
                        style={{
                          fontSize: "18px",
                          width: "80px",
                          justifyContent: "normal",
                        }}
                      >
                        Track:
                      </label>
                      <select
                        id="TrackID"
                        name="TrackID"
                        className="form-control"
                        value={newAltCategory.TrackID || ""}
                        style={{ width: "370px" }}
                        onChange={onChangeNewAltCategory}
                      >
                        {filteredTracks.length !== 0 ? (
                          filteredTracks.map((track, i) => (
                            <option key={i} value={track.TrackID}>
                              {track.TrackCode} - {track.TrackName}
                            </option>
                          ))
                        ) : (
                          <option>
                            No Tracks to display for the selected Provider
                          </option>
                        )}
                      </select>
                    </div>
                    {/* Category */}
                    <div className="form-group mt-3">
                      <label
                        className="lead"
                        style={{
                          fontSize: "18px",
                          width: "80px",
                          justifyContent: "normal",
                        }}
                      >
                        Category:
                      </label>
                      <select
                        id="IDTrackCategory"
                        name="IDTrackCategory"
                        className="form-control"
                        value={newAltCategory.IDTrackCategory}
                        style={{ width: "370px", display: "inline-block" }}
                        onChange={onChangeNewAltCategory}
                      >
                        {trackCategoryCbx.map((category, i) => {
                          return (
                            <option key={i} value={category.IDTrackCategory}>
                              {category.Description}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    {/* Profiles */}
                    <div
                      className="form-group"
                      style={{
                        maxHeight: "400px",
                        overflow: "auto",
                        boxShadow: "-10px 5px 15px #d9e6f2",
                      }}
                    >
                      <table className="table table-hover table-sm">
                        <thead
                          style={{
                            position: "sticky",
                            top: "0",
                            background: "#000",
                            color: "#fff",
                          }}
                        >
                          {headers}
                        </thead>
                        <tbody className="table-lg">{tableProfiles}</tbody>
                      </table>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success"
                onClick={() => insertAltCategory(newAltCategory)}
              >
                Save
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => cleanInputs()}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewAltCategoryModal;
